import React from 'react';
import PropTypes from 'prop-types';
import { AdvertisementContainer } from './AdvertisementManager.style';
import { Carousel } from './Carousel';

const AdvertisementManager = ({ children, offers, offerCallback }) => {
    return (
        <AdvertisementContainer className="odf-nospace-inner-bottom">
            <Carousel onButtonClick={offerCallback} slides={offers}>
                {children}
            </Carousel>
        </AdvertisementContainer>
    );
};

AdvertisementManager.propTypes = {
    children: PropTypes.node,
    offers: PropTypes.array.isRequired,
    offerCallback: PropTypes.func,
};

AdvertisementManager.defaultProps = {
    children: null,
    offerCallback: () => {},
};

export { AdvertisementManager };
